import type { FilterItem } from 'widgets/FilterEditor/model'

const PowerDialerStatusKeys = new Set(['pd_campaign.status'])

export const isPowerDialerStatusWidget = (filterItem: FilterItem) =>
  PowerDialerStatusKeys.has(filterItem.key)
